import RejectOrder from "../symbols/rejectOrder";
import { HttpRequestPost } from "../../service";

const getRejectOrderAction = (payload: any) => ({
  type: RejectOrder.REJECT_ORDER,
  payload,
});
const getRejectOrderSuccessAction = (payload: any) => ({
  type: RejectOrder.REJECT_ORDER_SUCCESS,
  payload,
});
const getRejectOrderFailureAction = () => ({
  type: RejectOrder.REJECT_ORDER_FAILURE,
});
const clearRejectOrderAction = () => ({
  type: RejectOrder.CLEAR_REJECT_ORDER,
});

export function getRejectOrder(deliveryId: string) {
  return (dispatch: any) => {
    dispatch(getRejectOrderAction({}));

    HttpRequestPost(
      `/portal/delivery/${deliveryId}/reject`,
      dispatch,
      getRejectOrderSuccessAction,
      getRejectOrderFailureAction,
      true,
      {}
    );
  };
}

export function clearRejectOrder() {
  return (dispatch: any) => {
    dispatch(clearRejectOrderAction());
  };
}
